import React from "react";
import AddressForm from "../Components/Shipping/AddressForm";
import Checkout from "../Components/Shipping/Checkout";

const Shipping = () => {
  return (
    <>
      <Checkout />
    </>
  );
};

export default Shipping;
